import { useState, useEffect, useCallback, useRef } from "react";
import {
  Heading,
  Box,
  Text,
  Flex,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Button,
  useColorModeValue,
  useMediaQuery,
  IconButton
} from "@chakra-ui/react";
import { AiOutlineCamera } from 'react-icons/ai';
import {
  FlexibleWidthXYPlot,
  VerticalBarSeries,
  Hint,
  VerticalGridLines,
  HorizontalGridLines,
  XAxis,
  YAxis,
  GradientDefs,
  AreaSeries,
  MarkSeries,
} from "react-vis";
import moment from "moment";
import PuffLoader from "react-spinners/PuffLoader";
import { MdBarChart } from "react-icons/md";
import { AiOutlineLineChart } from "react-icons/ai";
import { useOnClickOutside } from "utils/helpers";
import numbro from "numbro";
import { yDomain } from "./utils";
import { layerStyle, textStyle } from "theme/names";
const findNumSign = (num) => (num > 0) ? "+" : "";
interface BigGraphProps {
  stats: any,
  type?: string,
  bigGraphOf: string,
  isLoading?: boolean,
  bigGraphTotalCounts?: number,
  previousDayStat: any,
  hintButtonOnClick?: any,
  canScreenshot?: boolean,
  disableSeePosts?: boolean,
  takeScreenshot?: any,
}

export const BigChangeableGraph = ({
  stats = [],
  bigGraphOf = "Followers",
  isLoading = true,
  bigGraphTotalCounts = 0,
  previousDayStat = [],
  hintButtonOnClick = (date) => { },
  canScreenshot = false,
  takeScreenshot = (...args: any | undefined) => { },
  disableSeePosts = false,
}: BigGraphProps) => {
  const [graphType, setGraphType] = useState("line");
  const [graphOf, setGraphOf] = useState(bigGraphOf);
  const [graphData, setGraphData] = useState([...stats]);
  const [showCrosshairAt, setShowCrosshairAt] = useState({ date: "", x: "-9999", y: "-9999" });
  //const showCrosshairAt = useRef({date:"", x:"-9999", y:"-9999"});
  const [showCrosshair, setShowCrosshair] = useState(false);
  const [totalCounts, setTotalCounts] = useState(bigGraphTotalCounts);
  const [prevCountValue, setPrevCountValue] = useState(0);
  // const prevCountValue = useRef(0);
  // const totalCounts = useRef(0);
  const [previosDayStatsValue, setPreviousDayStatsValue] = useState(previousDayStat);
  const crosshairHintRef = useRef();
  const darkModeGridLinesColor = useColorModeValue("#CBCBCB", "#3F3F3F");
  const darkModeSnapshotColor = useColorModeValue('gray.400', 'gray.600');
  const darkModeSnapshotColorHover = useColorModeValue('#11BB8D', '#93eed5');
  const [isTooSmall] = useMediaQuery("(max-width: 840px)");
  const [barGraphData, setBarGraphData] = useState<any>([...stats]);
  const lineAnimationSettings = { damping: 75, stiffness: 270 };
  const [animationOn, setAnimationOn] = useState(lineAnimationSettings);
  const [isGenerating, SetIsGenerating] = useState<boolean>(true);
  const [showLoader, setShowLoader] = useState<boolean>(isLoading || isGenerating);
  const [tickFormatDivisor, setTickFormatDivisor] = useState(7);
  const gridLineCSS = {
    "stroke": darkModeGridLinesColor,
    'strokeDasharray': "3,3",
    "display": (graphData?.length > 31 || isTooSmall) ? "none" : "inline",
  };

  const markLineCss = {
    "display": (isTooSmall && graphData.length > 7) ? "none" : "inline",
    //"cursor":"pointer",
  }

  // const yDomain = useCallback(
  //     (data) => {
  //         const y = data.map((s)=>{
  //             return s?.y || 0;
  //         });

  //         const yD =[
  //            ((Math.min(...y) * 0.95)),
  //            ((Math.max(...y) * 1.05))
  //         ]

  //         return yD;
  //     }, [graphData, barGraphData, graphOf]
  // );

  //for followers
  const calculateBarGraphDataPoints =
    useCallback(
      () => {
        let barData = [...stats];
        if (previousDayStat?.prevPeriodAccountStats?.length > 0) {
          barData = barData.map(
            (dataPoint, i, arr) => {
              let newDataPoint = { ...dataPoint }
              newDataPoint.y = (i == 0)
                ? dataPoint?.y - previousDayStat.prevPeriodAccountStats[previousDayStat?.prevPeriodAccountStats?.length - 1]?.followerCount || 0
                : dataPoint?.y - arr[i - 1]?.y;
              return newDataPoint;
            }
          );
        }

        return barData;
      }, [stats, bigGraphOf, previousDayStat]
    );



  const calculatePrevTotalCounts =
    useCallback(
      () => {
        let prevDayAccount = previousDayStat?.prevPeriodAccountStats;
        let allPostsOnPrevDay;
        if (prevDayAccount && prevDayAccount?.length > 0) {

          prevDayAccount = previousDayStat?.prevPeriodAccountStats[previousDayStat?.prevPeriodAccountStats?.length - 1];
          const calcPrevDay = moment.utc(stats[0]?.date, "MMM. Do ’YY").subtract(1, "days").startOf("day")?.format("MMM. Do ’YY")
            || moment.utc(prevDayAccount?.dateFetched?.toDate
              ? prevDayAccount?.dateFetched?.toDate()
              : new Date(previousDayStat?.prevPeriodTweetStats[0]?.created_at._seconds * 1000))?.format("MMM. Do ’YY");

          allPostsOnPrevDay = (previousDayStat?.prevPeriodTweetStats.length > 0)
            ?
            previousDayStat?.prevPeriodTweetStats?.filter((t) => {

              const dateOfIndex = (previousDayStat?.mode == "personal") && t?.created_at.toDate
                ? moment.utc(t?.created_at.toDate ? t?.created_at.toDate() : new Date(t?.created_at._seconds * 1000))?.format("MMM. Do ’YY")
                : moment.utc(new Date().setTime(t?.dateAdded?._seconds * 1000))?.format("MMM. Do ’YY");

              return (calcPrevDay == dateOfIndex);

            })
            :
            [];

        }


        let prevDayStats = {
          followers: prevDayAccount?.followerCount || 0,
          engagements: 0,
          posts: allPostsOnPrevDay?.length || 0,
          comments: 0,
          impressions: 0,
          profileviews: prevDayAccount?.viewCounts || 0,
          likes: 0,
          shares: 0,
          undefined: '',
        }

        if (allPostsOnPrevDay && allPostsOnPrevDay?.length > 0) {
          allPostsOnPrevDay.forEach((p) => {
            prevDayStats.impressions += p?.numViews || 0;
            prevDayStats.engagements += (p?.numLikes ?? 0) + (p?.totalShares ?? 0) + (p?.numComments ?? 0);
            prevDayStats.comments += (p?.numComments ?? 0);
            prevDayStats.likes += (p?.numLikes ?? 0);
            prevDayStats.shares += (p?.totalShares ?? 0);
          });
        }
        return prevDayStats;
      }
      , [previousDayStat, stats, bigGraphOf]);

  const updateValueState = () => {
    setGraphData([...stats]);
    //setGraphData([]); //for testing...
    setGraphOf(bigGraphOf);
    setShowCrosshairAt({ date: "", x: "-9999", y: "-9999" });
    setTotalCounts(bigGraphTotalCounts);
    setShowCrosshair(false);
    setPreviousDayStatsValue({ ...calculatePrevTotalCounts() });
    (bigGraphOf.toLowerCase() == "followers")
      ? setBarGraphData([...calculateBarGraphDataPoints()])
      : setBarGraphData([...stats]);
    SetIsGenerating(false);
    setTickFormatDivisor((graphData?.length > 32 && graphData?.length < 99) ? 7 : 30);
  }

  const onPointClick = async (d, event) => {

    const gd = (graphType == "line")
      ?
      [...graphData]
      :
      [...barGraphData];

    setShowCrosshairAt({ date: d.date, x: d.x, y: d.y });
    let index = gd.findIndex((n) => {
      return n?.date === d?.date
    });
    // needs refactor - manoj
    if (index > 0) {

      (graphOf.toLowerCase() == "followers" && graphType == "bar")
        ?
        setPrevCountValue(Math.floor(d?.y) || 0)
        :
        setPrevCountValue(Math.floor(d?.y - gd[index - 1]?.y))
        ;
      // (graphOf.toLowerCase() == "followers" || graphOf.toLowerCase() == "profile views")
      //     ?
      //         prevCountValue.current = (d?.y - gd[index - 1]?.y)
      //     : 
      //         prevCountValue.current = (d?.y || 0)
      //     ;

      (graphOf.toLowerCase() == "followers" && graphType == "line")
        ?
        setTotalCounts(Math.floor(d?.y) || 0)
        : (graphOf.toLowerCase() == "followers" && graphType == "bar")
          ?
          setTotalCounts(Math.floor(gd[index]?.followerCount) || 0)
          :
          setTotalCounts(Math.floor(bigGraphTotalCounts) || 0);
    }
    else {
      (graphOf.toLowerCase() == "followers" && graphType == "bar")
        ?
        setPrevCountValue(Math.floor(gd[0]?.followerCount - previosDayStatsValue[graphOf?.toLowerCase().replace(/\s/g, '')]))
        :
        setPrevCountValue(Math.floor(gd[0]?.y - previosDayStatsValue[graphOf?.toLowerCase().replace(/\s/g, '')]));

      (graphOf.toLowerCase() == "followers" && graphType == "line")
        ?
        setTotalCounts(Math.floor(gd[0]?.y) || 0)
        :
        (graphOf.toLowerCase() == "followers" && graphType == "bar")
          ?
          setTotalCounts(Math.floor(gd[index]?.followerCount) || 0)
          :
          setTotalCounts(Math.floor(bigGraphTotalCounts) || 0);
    }

    if (bigGraphTotalCounts == 0 && graphOf.toLowerCase() == "followers" && gd[0]?.y == 0) {
      setPrevCountValue(0);
      setTotalCounts(Math.floor(previosDayStatsValue[graphOf?.toLowerCase().replace(/\s/g, '')]));
    }

    if (graphOf.toLowerCase() != "followers" && graphOf.toLowerCase() != "profile views") {
      setPrevCountValue(Math.floor(d?.y) || 0)
    }

    setShowCrosshair(true);
  }

  const onValuePoint = (d, info) => {
    //@ts-ignore
    setAnimationOn(null);

    if (!showCrosshair) {
      onPointClick(d, info);
    }
  }

  const hintListener = useCallback(
    (event) => {
      let removeHint = false;
      const barHint = document.getElementById("barHintBoxCrossHair");
      const lineHint = document.getElementById("lineHintBoxCrossHair");

      removeHint = (
        !(barHint?.contains(event?.target) || event?.target?.contains(barHint)) || (lineHint?.contains(event?.target) || event?.target?.contains(lineHint))
      );

      if (showCrosshair && removeHint) {
        setShowCrosshairAt({ date: "", x: "-9999", y: "-9999" });
        setShowCrosshair(false);
      }

      removeHint && removeEventListener('mousemove', hintListener);
      (!animationOn && removeHint) && setAnimationOn(lineAnimationSettings);
    }, [showCrosshair, showCrosshairAt]);

  const offValuePoint = (d, info) => {
    addEventListener('mousemove', hintListener);
    //const hintBox = document.getElementsByClassName("rv-hint")[0]; //cant assing ref
    //@ts-ignore
  }

  const tickFormat = (d, i, scale, tickTotal) => {
    //needs refactor - manoj
    if (graphData.length < 32) {
      return (!isTooSmall)
        ?
        moment.utc(graphData[i]?.date, "MMM. Do YY").format("DD/MM").toString()
        :
        (graphData.length < 8) ? moment.utc(graphData[i]?.date, "MMM. Do YY").format("DD/MM").toString() : ""
        ;
    } else {
      return (!isTooSmall)
        ?
        (i % tickFormatDivisor == 0)
          ? moment.utc(graphData[i]?.date, "MMM. Do YY").format("DD/MM").toString()
          : ""
        :
        (i % tickFormatDivisor == 0)
          ? (graphData.length < 8)
            ? moment.utc(graphData[i]?.date, "MMM. Do YY").format("DD/MM").toString()
            : ""
          : ""

        ;
    }
  }

  const yTickFormat = (d, i, scale, tickTotal) => {
    return numbro(d).format(
      {
        thousandSeparated: true,
        mantissa: 0
      }
    );
  }

  useEffect(() => {
    updateValueState();
    // console.log(stats, bigGraphOf, previousDayStat, 'stats check - big graph');
  }, [stats, bigGraphOf, previousDayStat, bigGraphTotalCounts]);

  useEffect(() => {
    setShowLoader(isLoading || isGenerating);
  }, [isLoading, isGenerating]);

  const hideOnClickOutside = useCallback(
    async (event) => {
      const hintBox = document.getElementsByClassName("rv-hint")[0];

      //@ts-ignore
      if (showCrosshair && !(hintBox?.contains(event?.target) || crosshairHintRef.current?.contains(event?.target))) {
        setShowCrosshairAt({ date: "", x: "-9999", y: "-9999" });
        setShowCrosshair(false);
        setAnimationOn(lineAnimationSettings);
        window?.removeEventListener('mousemove', hideOnClickOutside);
      }
      await new Promise((resolve) => setTimeout(resolve, 200));
    }, [showCrosshair, showCrosshairAt]
  );

  useOnClickOutside(crosshairHintRef, async (event) => {
    hideOnClickOutside(event);
  });

  const onClickSnapshot = () => {
    takeScreenshot({ data: { type: bigGraphOf, stats: graphData, 'labelValue': bigGraphTotalCounts, percentageValue: 0, graphType }, screenshotType: "big_graph" });
  }

  return (
    <>
      {showLoader ? (
        <Box maxW={1200}>
          <PuffLoader
            color={"#0A66C2"}
            loading={showLoader}
            cssOverride={{
              display: "block",
              margin: "0 auto",
              borderColor: "red",
            }}
            size={50}
          />
        </Box>
      ) : (
        <Flex
          alignItems="start"
          flexDirection="column"
          position="relative"
          w={"100%"}
        >
          <Heading fontSize="xl" mb="45px">
            {bigGraphOf} {graphOf.toLowerCase() == "followers" ? "Gain" : ""}
            {canScreenshot && (
              <IconButton
                p={1}
                m={3}
                variant="outline"
                size={"md"}
                border={0}
                icon={<AiOutlineCamera />}
                onClick={() => {
                  onClickSnapshot();
                }}
                cursor="pointer"
                aria-label="Take Stat Screenshot"
                color={darkModeSnapshotColor}
                _hover={{
                  color: darkModeSnapshotColorHover,
                }}
              />
            )}
          </Heading>
          <Tabs
            variant="light"
            // variant="unstyled"
            colorScheme="green"
            align="end"
            w="100%"
            position="relative"
            marginTop="-70px"
            isLazy={false}
          >
            <TabList w="100%">
              <Tab
                // fontWeight="bold"
                // color="#666666"
                onClick={() => {
                  setGraphType("line");
                  updateValueState();
                }}
              >
                <AiOutlineLineChart style={{ marginRight: "4px" }} /> Line
              </Tab>
              <Tab
                // fontWeight="bold"
                // color="#666666"
                onClick={() => {
                  setGraphType("bar");
                  updateValueState();
                }}
              >
                <MdBarChart style={{ marginRight: "4px" }} /> Bar
              </Tab>
            </TabList>
            <TabPanels w="100%">
              <TabPanel
                w="100%"
              // for={graphType}
              >
                {graphData && graphData?.length > 0 ? (
                  <Box
                    display="flex"
                    flexDirection="row"
                    w="100%"
                    margin={"auto"}
                    padding={["0px", "5px"]}
                  >
                    <FlexibleWidthXYPlot
                      height={330}
                      animation={animationOn}
                      xType="ordinal"
                      yDomain={yDomain(graphData)}
                      margin={{ left: 72, right: 0, top: 10, bottom: 40 }}
                      w="100%"
                    >
                      <VerticalGridLines style={gridLineCSS} />
                      <HorizontalGridLines style={gridLineCSS} />
                      <XAxis
                        attr="x"
                        attrAxis="y"
                        orientation="bottom"
                        tickFormat={tickFormat}
                        title="Date/Time"
                        tickLabelAngle={-30}
                      />
                      <YAxis
                        attr="y"
                        attrAxis="x"
                        orientation="left"
                        title={graphOf}
                        tickFormat={yTickFormat}
                        style={
                          {
                            //display:"none"
                          }
                        }
                      />
                      <GradientDefs>
                        <linearGradient
                          id="CoolGradient"
                          x1="0"
                          x2="0"
                          y1="0"
                          y2="1"
                        >
                          <stop
                            offset="0%"
                            stopColor="#11BB8D"
                            stopOpacity={0.4}
                          />
                          <stop
                            offset="100%"
                            stopColor="#93eed5"
                            stopOpacity={0.3}
                          />
                        </linearGradient>
                      </GradientDefs>

                      <AreaSeries
                        data={graphData}
                        opacity={1}
                        style={{
                          fill: "url(#CoolGradient)",
                          stroke: "#11BB8D",
                          strokeWidth: "0px",
                        }}
                      />

                      <MarkSeries
                        data={graphData}
                        color="#11BB8D"
                        onValueClick={onValuePoint}
                        onValueMouseOver={onValuePoint}
                        onValueMouseOut={offValuePoint}
                        size="4"
                        style={markLineCss}
                      />
                      <Hint
                        value={showCrosshairAt}
                        align={{ horizontal: "left", vertical: "top" }}
                        style={{
                          marginBottom: "-3px",
                          zIndex: "9999",
                          pointerEvents: "initial",
                        }}
                        className="linehintboxClass"
                      >
                        <HintBox
                          showCrosshairAt={showCrosshairAt}
                          showCrosshair={showCrosshair}
                          prevCountValue={prevCountValue}
                          graphOf={graphOf}
                          totalCounts={totalCounts}
                          crosshairHintRef={crosshairHintRef}
                          id="lineHintBoxCrossHair"
                          hintButtonOnClick={hintButtonOnClick}
                          setShowCrosshair={setShowCrosshair}
                          setShowCrosshairAt={setShowCrosshairAt}
                          setAnimationOn={setAnimationOn}
                          disableSeePosts={disableSeePosts}
                        />
                      </Hint>
                    </FlexibleWidthXYPlot>
                  </Box>
                ) : (
                  <Box
                    display="flex"
                    flexDirection="row"
                    w="100%"
                    style={{ padding: "5px", margin: "auto" }}
                  >
                    <Text textStyle={textStyle["body.medium.light"]}>
                      No graph to display
                    </Text>
                  </Box>
                )}
              </TabPanel>
              <TabPanel
              // for={graphType}
              >
                {barGraphData && barGraphData?.length > 0 ? (
                  <Box
                    display="flex"
                    flexDirection="row"
                    w="100%"
                    style={{ padding: "5px", margin: "auto" }}
                  >
                    <FlexibleWidthXYPlot
                      height={330}
                      animation={animationOn}
                      xType="ordinal"
                      yDomain={yDomain(barGraphData)}
                      margin={{ left: 72, right: 5, top: 10, bottom: 40 }}
                      w="100%"
                    >
                      <VerticalGridLines style={gridLineCSS} />
                      <HorizontalGridLines style={gridLineCSS} />
                      <XAxis
                        attr="x"
                        attrAxis="y"
                        orientation="bottom"
                        tickFormat={tickFormat}
                        title="Date/Time"
                        tickLabelAngle={-30}
                      />
                      <YAxis
                        attr="y"
                        attrAxis="x"
                        orientation="left"
                        title={graphOf}
                        tickFormat={yTickFormat}
                        style={
                          {
                            //display:"none"
                          }
                        }
                      />
                      <GradientDefs>
                        <linearGradient
                          id="CoolGradient"
                          x1="0"
                          x2="0"
                          y1="0"
                          y2="1"
                        >
                          <stop
                            offset="0%"
                            stopColor="#11BB8D"
                            stopOpacity={0.4}
                          />
                          <stop
                            offset="100%"
                            stopColor="#93eed5"
                            stopOpacity={0.3}
                          />
                        </linearGradient>
                      </GradientDefs>
                      <VerticalBarSeries
                        data={barGraphData}
                        opacity={1}
                        color="#11BB8D"
                        style={{
                          fill: "url(#CoolGradient)",
                          stroke: "#11BB8D",
                          strokeWidth: "0px",
                          //cursor:"pointer",
                        }}
                        onValueClick={onValuePoint}
                        onValueMouseOver={onValuePoint}
                        onValueMouseOut={offValuePoint}
                        barWidth={0.6}
                      />
                      <Hint
                        value={showCrosshairAt}
                        align={{ horizontal: "auto", vertical: "top" }}
                        style={{
                          marginBottom: "-3px",
                          zIndex: "9999",
                          pointerEvents: "initial",
                        }}
                        className="barhintboxClass"
                      >
                        <HintBox
                          showCrosshairAt={showCrosshairAt}
                          showCrosshair={showCrosshair}
                          prevCountValue={prevCountValue}
                          graphOf={graphOf}
                          totalCounts={totalCounts}
                          crosshairHintRef={crosshairHintRef}
                          id="barHintBoxCrossHair"
                          hintButtonOnClick={hintButtonOnClick}
                          setShowCrosshair={setShowCrosshair}
                          setShowCrosshairAt={setShowCrosshairAt}
                          setAnimationOn={setAnimationOn}
                          disableSeePosts={disableSeePosts}
                        />
                      </Hint>
                    </FlexibleWidthXYPlot>
                  </Box>
                ) : (
                  <Box
                    display="flex"
                    flexDirection="row"
                    w="100%"
                    style={{ padding: "5px", margin: "auto" }}
                  >
                    <Text textStyle={textStyle["body.medium.light"]}>
                      No Graph to Display
                    </Text>
                  </Box>
                )}
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
      )}
    </>
  );
}

const HintBox = ({
  showCrosshairAt,
  showCrosshair,
  prevCountValue,
  graphOf,
  totalCounts,
  crosshairHintRef,
  id,
  hintButtonOnClick,
  setShowCrosshair,
  setShowCrosshairAt,
  setAnimationOn,
  disableSeePosts = false,
}) => {
  const darkModeSeePostButtonColor = useColorModeValue("blue", "#1E1E1E");
  return (
    <Box
      h={138}
      w={150}
      borderRadius={7.83}
      p={0}
      m={0}
      zIndex={9999}
      layerStyle={layerStyle["bg.border.rounded"]}
      // background="white"
      // border="2px solid #E4E4E4"
      // color="#4E4E4E"
      //display="flex"
      display={showCrosshair ? "flex" : "none"}
      flexDirection="column"
      justifyContent="center"
      justifyItems="center"
      ref={crosshairHintRef}
      id={id}
      onMouseLeave={(event) => {
        setShowCrosshair(false);
        setShowCrosshairAt({ date: "", x: "-9999", y: "-9999" });
        setAnimationOn({ damping: 75, stiffness: 270 });
      }}
    >
      <Text
        color="#AEAEAE"
        w="full"
        textAlign="left"
        p={0} // b={0}
        pl={5}
        pt={0}
        fontSize={12}
        fontWeight="600"
      >
        {showCrosshairAt?.date || "No Date"}
      </Text>
      <Box
        display="flex"
        flexDirection="row"
        flexWrap="nowrap"
        justifyContent="left"
        p={5}
        pt={2}
        pb={2}
      >
        <Box w="50%" display="flex" flexDirection="column" placeItems="left">
          <Text
            textAlign="left"
            fontWeight={600}
            color={
              findNumSign(prevCountValue) == "+" ||
                (graphOf.toLowerCase() == "profile views" &&
                  prevCountValue == 0)
                ? "#11BB8D"
                : "#8511BB"
            }
            fontSize={14}
          >
            {graphOf.toLowerCase() == "profile views" && prevCountValue == 0
              ? "+"
              : ""}
            {numbro(prevCountValue).format({
              thousandSeparated: true,
              forceSign:
                graphOf.toLowerCase() != "followers" &&
                  graphOf.toLowerCase() != "profile views"
                  ? false
                  : true,
            })}
          </Text>
          <Text
            color="#4E4E4E"
            textTransform="uppercase"
            fontSize={7.83}
            textAlign="left"
            fontWeight="600"
            pt={1}
          >
            {graphOf.toLowerCase() == "followers" ? "New" : ""}
          </Text>
          <Text
            color="#4E4E4E"
            textTransform="uppercase"
            fontSize={7.83}
            textAlign="left"
            fontWeight="600"
          >
            {graphOf}
          </Text>
        </Box>
        <Box
          w="50%"
          display="flex"
          flexDirection="column"
          placeItems="left"
          ml={3}
        >
          <Text
            textAlign="left"
            fontWeight={600}
            color="#11BB8D"
            fontSize={14}
          >
            {numbro(totalCounts).format({
              thousandSeparated: true,
            })}
          </Text>
          <Text
            color="#4E4E4E"
            textTransform="uppercase"
            fontSize={7.83}
            textAlign="left"
            fontWeight="600"
            pt={1}
          >
            Total
          </Text>
          <Text
            color="#4E4E4E"
            textTransform="uppercase"
            fontSize={7.83}
            textAlign="left"
            fontWeight="600"
          >
            {graphOf}
          </Text>
        </Box>
      </Box>
      {/* <Button placeSelf="center" cursor="pointer" border="1px solid #35517E" w="50%" h={21.93} p={0}  m={0} mt={2} fontSize={11} color="#35517E" fontWeight="600" onClick={()=>{ */}
      {!disableSeePosts && (
        <Button
          placeSelf="center"
          // w="50%"
          // p={0} m={0} mt={2}
          size="sm"
          variant="secondary"
          colorScheme={darkModeSeePostButtonColor}
          // fontWeight="600"
          onClick={() => {
            hintButtonOnClick(showCrosshairAt?.date);
          }}
          zIndex="9999"
        >
          See Posts
        </Button>
      )}
    </Box>
  );
}
